import(/* webpackMode: "eager" */ "/vercel/path0/app/url-shortener/page.tsx");
